import { useMemo } from 'react';

import { isSsrSafePathname } from '@/lib/experiments/cacheablePages';
import { ACTIVE_EXPERIMENTS } from '@/lib/experiments/experimentRegistry';
import { useExperimentAssignments } from '@/providers/ExperimentProvider';

import { useExperimentHydrated } from './useExperimentHydration';
import { useRouter } from './useRouter';

function buildControlAssignments(): Record<string, string> {
  return ACTIVE_EXPERIMENTS.reduce<Record<string, string>>(
    (acc, experiment) => {
      if (experiment.shipped && experiment.enabled) {
        acc[experiment.name] = experiment.controlVariant;
      }
      return acc;
    },
    {},
  );
}

export function useAnalyticsExperimentAssignments(): Record<string, string> {
  const assignments = useExperimentAssignments();
  const { pathname } = useRouter();
  const hydrated = useExperimentHydrated();

  return useMemo(() => {
    if (hydrated || isSsrSafePathname(pathname)) {
      return assignments;
    }

    return buildControlAssignments();
  }, [assignments, hydrated, pathname]);
}
